module.exports = __webpack_public_path__ + "img/contact_icon_2.8203e0ea.png";